import { NgModule } from '@angular/core';

import { ContextBubbleComponent } from './component';
import { LKIcon } from '../icon/module';
import { BrowserModule } from '@angular/platform-browser';
import { BubbleBodyComponent, BubbleLinkComponent } from './element';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

@NgModule({
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    LKIcon
  ],
  declarations: [ContextBubbleComponent, BubbleBodyComponent, BubbleLinkComponent],
  exports : [ContextBubbleComponent, BubbleBodyComponent, BubbleLinkComponent]
})
export class LKContextBubble {}
